module.exports = __webpack_public_path__ + "static/media/logo-overlay.f1775c3b.png";